import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { videoControllerIcon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type VideoControllerIconProps = Omit<AssetIconProps, 'src' | 'alt'> & {
  selected?: boolean;
};

/** Video recorder glyph — AG default; HID blue glyph unselected, #0057B7 tile + white icon when selected. */
export function VideoControllerIcon({
  selected = false,
  size = 33,
  className,
  ...props
}: VideoControllerIconProps) {
  const brandConfig = getBrandConfig();

  if (
    APP_BRAND === 'hid' &&
    brandConfig.hidVideoControllerUnclickedIcon &&
    brandConfig.hidVideoControllerSelectedIcon
  ) {
    return (
      <AssetIcon
        src={selected ? brandConfig.hidVideoControllerSelectedIcon : brandConfig.hidVideoControllerUnclickedIcon}
        size={size}
        className={className}
        {...props}
      />
    );
  }

  return <AssetIcon src={videoControllerIcon} size={size} className={className} {...props} />;
}
